<template>
  <div class="d-flex flex-column  align-center ga-5 w100 pa-5 fill-height">
    <div class="d-flex flex-column align-center ga-1">
      <div class="d-flex align-center ga-2">
        <v-icon style="font-size: 40px; color: #43BA7E;">
          mdi-qrcode
        </v-icon>
        <h1>{{ title }}</h1>
      </div>
      <span
        style="color: rgba(0,0,0,0.6); font-size: 20px; font-weight: 500;"
      >{{ secondTitle }}</span>
    </div>
    <div class="d-flex ga-6">
      <v-btn
        class="pt-8 pb-8 pl-16 pr-16"
        style="border-radius: 6px;"
        color="primary"
        :outlined="isTyping ? true : false"
        @click="isTyping = false"
      >
        <div class="d-flex align-center ga-2">
          <v-icon style="font-size: 26px;">
            mdi-camera
          </v-icon>
          <span style="font-size: 20px;"> Scan QR Code</span>
        </div>
      </v-btn>
      <v-btn
        class="pt-8 pb-8 pl-16 pr-16"
        style="border-radius: 6px;"
        color="primary"
        :outlined="isTyping ? false : true"
        @click="isTyping = true"
      >
        <div class="d-flex align-center ga-2">
          <v-icon style="font-size: 26px;">
            mdi-keyboard
          </v-icon>
          <span style="font-size: 20px;"> Type Code</span>
        </div>
      </v-btn>
    </div>
    <div
      style="border: 1px solid #E4E4E7; border-radius: 10px; min-width: 700px;"
      class="d-flex flex-column pa-4"
    >
      <h2>{{ isTyping ? 'Manual Code Entry' : 'QR Code Scanner' }}</h2>
      <span
        style="color: rgba(0,0,0,0.6); font-size: 16px; font-weight: 500;"
      >{{ isTyping ? 'Enter the QR/UPC/MPQR code manually' : 'Position the QR code within the frame to scan' }}</span>
      <div>
        <div
          v-if="isTyping"
          class="d-flex flex-column ga-2 pt-4"
        >
          <span>Code</span>
          <v-text-field
            v-if="isTyping"
            v-model="qrCode"
            outlined
            placeholder="Enter QR/UPC/MPQR code"
            hide-details
          />
          <v-btn
            class="pa-6"
            color="success"
            @click="manualEntered()"
          >
            Submit Code
          </v-btn>
        </div>
        <div
          v-else
          style="min-height: 400px;"
          class="d-flex flex-column"
        >
          <qrcode-stream
            :camera="camera"
            :track="paintBoundingBox"
            @decode="processResult"
            @init="onInit"
          >
            <canvas
              id="square-canvas"
              class="overlay-line"
            />
          </qrcode-stream>
          <div class="d-flex align-center justify-center w100">
            <v-btn
              color="primary"
              class="pa-5"
              outlined
              style="font-size: 1.1em; margin-top: 75px"
              @click="changeCamera"
            >
              Switch Back/Front Camera
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div
      style="background-color: #F0F6FF; border: 1px solid #C5DBFF; border-radius: 10px; min-width: 700px;"
      class="pa-4 d-flex flex-column ga-1"
    >
      <span
        style="color: #335FCD"
        class="fw500"
      >Instructions: </span>
      <div class="d-flex flex-column ga-1">
        <span style="color: #335FCD">- Ensure the QR code label is clean and undamaged</span>
        <span style="color: #335FCD">- Hold the device steady when scanning</span>
        <span style="color: #335FCD">- For manual entry, double-check the code accuracy</span>
        <span style="color: #335FCD">- Attach the label to the receiving bundle after scanning</span>
      </div>
    </div>
    <inventory-qr-form
      ref="tagForm"
    />
    <inventory-upc-form
      ref="upcForm"
    />
    <inventory-upc-new-form
      ref="newUpcForm"
      :entered-tag="qrCode"
      @submitQRCodeTag="submitQRCodeTag"
    />
    <inventory-qr-new-form
      ref="newQrForm"
      :entered-tag="qrCode"
      :is-show-p-o="true"
      :is-show-location="true"
      @submitQRCodeTag="submitQRCodeTag"
    />
    <InventoryMPQRForm
      ref="mpqrForm"
    />
    <confirm-form ref="confirmForm" />
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import { mapGetters, mapState } from 'vuex';
import InventoryQrForm from '@/components/forms/inventoryQrs/InventoryQrForm.vue';
import InventoryQrNewForm from '@/components/forms/inventoryQrs/InventoryQrNewForm.vue';
import InventoryUpcForm from '@/components/forms/inventoryQrs/InventoryUpcForm.vue';
import InventoryUpcNewForm from '@/components/forms/inventoryQrs/InventoryUpcNewForm.vue';
import InventoryMPQRForm from '@/components/forms/inventoryQrs/InventoryMPQRForm';

export default {
  components: {
    QrcodeStream, InventoryQrForm, InventoryUpcForm, InventoryQrNewForm, InventoryUpcNewForm, InventoryMPQRForm,
  },
  props: {
    msg: {
      type: String,
      default: '',
    },
    qrType: {
      type: String,
      default: '',
    },
    isRmSupply: Boolean,
    isPaintSupply: Boolean,
    isMovingQrPartially: Boolean,
    isPartPickList: Boolean,
  },
  data: () => ({
    loading: false,
    camera: 'rear',
    cameraState: '',
    error: '',
    openDialog: false,
    isQrEqualsTag: false,
    isTyping: false,
    qrCode: '',
    inventoryTag: '',
    isInventoryQr: false,
    isPhysicalCountQr: false,
    isRmReceivingQr: false,
    isMovingQr: false,
    textfieldTitle: 'QR/UPC/MPQR Code',
    secondTitle: 'Please place QR code into the green square',
    title: 'Scan QR',
    qrInputType: null,

    roles: [],

    userRoleIdAdmin: 3,
    inventoryClassIdMaintenance: 21,
  }),
  computed: {
    ...mapGetters([
      'businessRulesGetBoolean',
      'isPhysicalCountActivated',
      'currentPhysicalCount',
    ]),
    ...mapState({
      isQRCodeScan: 'isQRCodeScan',
      isDarkMode: 'isDarkMode',
      user: (state) => state.user,
    }),
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin);
    },
    validationPending() {
      return this.camera === 'off';
    },
    qrCodeIsMpqr() {
      return parseInt(this.qrCode, 10) > 199999 && parseInt(this.qrCode, 10) < 209999;
    },
    qrCodeIsUpc() {
      return parseInt(this.qrCode, 10) > 99999 && parseInt(this.qrCode, 10) < 199999;
    },
  },
  watch: {
    qrType: {
      immediate: true,
      handler(value) {
        if (!value) return;

        this.isInventoryQr = false;
        this.isPhysicalCountQr = false;
        this.isRmReceivingQr = false;
        this.isMovingQr = false;
        this.qrCode = '';
        switch (value) {
          case 'inventory-qr':
            this.isInventoryQr = true;
            break;
          case 'physical-count-qr':
            this.isPhysicalCountQr = true;
            break;
          case 'rm-receiving-qr':
            this.isRmReceivingQr = true;
            break;
          case 'moving-qr':
            this.isMovingQr = true;
            break;
          default:
        }
        this.setTitle();
      },
    },

    isTyping(val) {
      if (val) this.turnCameraOff();
      else this.turnCameraOn();

      if (!val) {
        this.$nextTick(async () => {
          this.manualBoundingBox();
        });
      }
      this.setTitle();
      this.$store.commit('storeIsQRCodeScan', val);
    },

    error(message) {
      this.$bus.$emit('showError', message);
    },
  },
  created() {
    this.isTyping = this.isQRCodeScan;
    this.roles = this.user.roles.map((x) => x.id);
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.$nextTick();
      this.turnCameraOn();

      this.manualBoundingBox();

      const QrEqualsTagBRName = 'QR Code Equals Inv. Tag';
      this.isQrEqualsTag = this.businessRulesGetBoolean(QrEqualsTagBRName);
    },

    async onInit(promise) {
      this.loading = true;
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: you need to grant camera access permisson';
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: no camera on this device';
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: secure context required (HTTPS, localhost)';
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: is the camera already in use?';
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: installed cameras are not suitable';
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: Stream API is not supported in this browser';
        }
      } finally {
        this.loading = false;
      }
    },

    turnCameraOn() {
      this.camera = 'rear';
    },

    turnCameraOff() {
      this.cameraState = this.camera;
      this.camera = 'off';
    },

    changeCamera() {
      this.camera = this.camera === 'front' ? 'rear' : 'front';
    },

    manualBoundingBox() {
      const boxSizes = [];
      boxSizes.push({
        boundingBox: {
          x: 50.5, y: 10.5, width: 200, height: 130,
        },
      });
      const canvas = document.getElementById('square-canvas');
      const ctx = canvas.getContext('2d');
      this.paintBoundingBox(boxSizes, ctx);
    },

    paintBoundingBox(detectedCodes, ctx) {
      // eslint-disable-next-line no-restricted-syntax
      for (const detectedCode of detectedCodes) {
        const {
          boundingBox: {
            x, y, width, height,
          },
        } = detectedCode;

        ctx.lineWidth = 1;
        ctx.strokeStyle = '#5cb984';
        ctx.strokeRect(x, y, width, height);
      }
    },

    async processResult(result) {
      this.turnCameraOff();
      const resultArray = result.split('/');
      const qrCodeNumberIdx = 4;
      this.qrCode = resultArray[qrCodeNumberIdx];
      this.getQrCode();
    },

    async getQrCode() {
      if (!this.qrCode || this.qrCode === null) return;

      // Inventory Qr
      if (this.isInventoryQr) {

        const res = await this.$api.inventoryTag.get(`${this.qrCode}`);
        
        if (res && res.status === 505) {
          this.$bus.$emit('showError', res.message);
          return;
        }

        const tag = res;
        //check if qrCode is maintenance class
        if (this.isMaintenanceClass(tag)) {
          //open dialog if non-admin
          //go to inventory-qr route if admin
          if (this.isAdmin) {
            this.$router.push(`/inventory-qr/${this.qrCode}`);
            return;
          } else {
            const confirm = await this.$refs.confirmForm.open({
              title: `Are you sure that you want to submit ${tag.item.name} as maintained?`,
            });
            if (!confirm) return;
            this.$bus.$emit('loading');
            const res = await this.$api.inventoryTag.get(`maintenance/${tag.inventory_tag}`);
            this.$bus.$emit('loading-stop');
            if (!res) {
              this.$bus.$emit('showError');
              return false;
            }

            this.$bus.$emit('showSuccess');
          }
          return;
        }

        this.$router.push(
          parseInt(this.qrCode, 10) > 199999 && parseInt(this.qrCode, 10) < 209999
            ? `/inventory-mpqr/${this.qrCode}`
            : `/inventory-qr/${this.qrCode}`
        );
        return;
      }

      // Physical Count
      if (this.isPhysicalCountQr && this.isPhysicalCountActivated) {
        // first we need to check if the qrCode exists in InventoryTags
        const submitModel = {
          filters: {
            inventory_tag: this.qrCode,
            is_qty_on_hand_o: 0,
          },
        };
        const res = await this.$api.inventoryTag.read(submitModel);
        if (res && res.status === 505) {
          this.$bus.$emit('showError', res.message);
          this.isActivatedVisible = true;
          return;
        }
        //#region Notes
        // if the qrCode exists in InventoryTags then we need to check if the class of the qr code is part of the physical count
        // if the class is part of the physical count, then we need to check if there already exists a physical count record for this qrCode
        // if yes, then we open InventoryQrForm
        // if no, then we open PhysicalCountQrForm
        // if the class is NOT part of the physical count, then we open Inventory QR Form
        // if the qrCode does not exist in InventoryTags, then we open RM Receiving QR Form
        //#endregion Notes
        if (res && res.data && res.data[0]) {
          if (this.qrCodeIsMpqr) {
            this.$router.push(`/inventory-mpqr/${this.qrCode}`);
            return;
          }
          // qr code exists in InventoryTags
          const inventoryTag = res.data[0];
          const inventoryClassId = inventoryTag.item.inventory_class_id;
          if (this.currentPhysicalCount && this.currentPhysicalCount.classes && this.currentPhysicalCount.classes.some((c) => c.id === inventoryClassId)) {
            // class is part of the physical count so we just go to Physical Count QR Form
            this.$router.push(`/physical-count-qr/${this.qrCode}`);
            return;
          }
          // class is NOT part of the physical count so we open Inventory QR Form
          this.$router.push(`/inventory-qr/${this.qrCode}`);
          return;
        }
        console.log('qrCode does not exist in InventoryTags');
        // qr code does not exist in InventoryTags
        // UPCs QR Codes: from 100000 to 199999
        if (this.qrCodeIsUpc) {
          this.$refs.newUpcForm.openDialog();
        } else if (this.qrCodeIsMpqr) {
          this.$refs.mpqrForm.open(this.qrCode);
        } else {
          this.$refs.newQrForm.openDialog();
        }
        return;

        // console.log('dunno what to do with this qrCode');
      }

      // RM Receiving
      if (this.isRmReceivingQr) {
        // let isUPC = false;
        // // UPCs QR Codes: from 100000 to 199999
        // if (parseInt(this.qrCode, 10) > 99999 && parseInt(this.qrCode, 10) < 199999) {
        // // Include records with qty on hand 0 for INSTALATION Class records
        //   isUPC = true;
        // }
        // if (parseInt(this.qrCode, 10) > 199999 && parseInt(this.qrCode, 10) < 209999) {
        // // Include records with qty on hand 0 for INSTALATION Class records
        //   isUPC = true;
        // }
        const submitModel = {
          filters: {
            inventory_tag: this.qrCode,
            is_qty_on_hand_o: 0,
            is_user_location: true,
          },
        };
        const res = await this.$api.inventoryTag.read(submitModel);
        if (res && res.status === 505) {
          this.$bus.$emit('showError', res.message);
          this.isActivatedVisible = true;
          return;
        }

        // UPCs QR Codes: from 100000 to 199999
        if (parseInt(this.qrCode, 10) > 99999 && parseInt(this.qrCode, 10) < 199999) {
        // Include records with qty on hand 0 for INSTALATION Class records
          if (!res || !res.data || !res.data[0]) {
            this.$refs.newUpcForm.openDialog();
          } else { this.$refs.upcForm.open(this.qrCode); }
        } else if (parseInt(this.qrCode, 10) > 199999 && parseInt(this.qrCode, 10) < 209999) {
          this.$refs.mpqrForm.open(this.qrCode);
        } else if (!res || !res.data || !res.data[0]) {
          this.$refs.newQrForm.openDialog();
        } else {
          this.$refs.tagForm.open(this.qrCode);
        }
      }

      // Moving QR
      if (this.isMovingQr) {
        if ((parseInt(this.qrCode, 10) > 199999 && parseInt(this.qrCode, 10) < 209999)) {
          this.$router.push(`/moving-qr/mpqr/${this.qrCode}`);
          return;
        }
        // if upc, show error message
        if (parseInt(this.qrCode, 10) > 99999 && parseInt(this.qrCode, 10) < 199999) {
          this.$bus.$emit('showError', 'UPC Codes cannot be relocated');
          this.isActivatedVisible = true;
          return;
        }
        this.$router.push(`/moving-qr/${this.qrCode}`);
      }

      // return to Supply to Line, Supply to Paint, Part Pick List
      if (this.isRmSupply || this.isPaintSupply || this.isPartPickList) {
        const { qrCode } = this;
        this.$emit('return-qr-code', qrCode);
        this.$nextTick(async () => {
          this.qrCode = '';
        });
      }

      // return to Moving Qr if moving partially
      if (this.isMovingQrPartially) {
        const { qrCode } = this;
        this.$emit('return-qr-code-move', qrCode);
        this.$nextTick(async () => {
          this.qrCode = '';
        });
      }
    },

    manualEntered() {
      this.getQrCode();
    },

    async submitQRCodeTag(msg) {
      if (!this.isRmReceivingQr && !this.isPhysicalCountQr) return;

      this.$bus.$emit('showSuccess', msg);

      if (this.isTyping) this.qrCode = '';

      else this.turnCameraOn();
    },

    async setTitle() {
      if (this.isMovingQr || this.isRmSupply || this.isPaintSupply || this.isPartPickList || this.isMovingQrPartially) {
        this.title = this.isTyping ? 'Type QR/UPC' : 'Scan QR/UPC';
        this.secondTitle = this.isTyping ? 'Please type QR/UPC Code into the field' : 'Please place QR/UPC code into the green square';
        return;
      }
      switch (this.qrType) {
        case 'inventory-qr':
          this.title = 'Inventory QR';
          if (this.isTyping) { this.secondTitle = 'Please type QR Code number of Inventory Item'; } else this.secondTitle = 'Please scan QR Code of Inventory Item';
          break;
        case 'physical-count-qr':
          await this.getActivePhysicalCountList();
          this.title = `Physical Count (${this.physicalCountList ? this.physicalCountList.name : ''}, as of ${new Date(`${this.physicalCountList ? this.physicalCountList.date : ''} 00:00`).toDateString().substring(4).replace(/^(\w+)\s/, '$1, ')})`;
          if (this.isTyping) { this.secondTitle = 'Please type QR Code number of Inventory Item that needs to be counted'; } else this.secondTitle = 'Please scan QR Code of Inventory Item that needs to be counted';
          break;
        case 'rm-receiving-qr':
          this.title = 'Raw Materials Receiving';
          if (this.isTyping) { this.secondTitle = 'Please attach the unused QR Code label to Receiving bundle and type its number'; } else this.secondTitle = 'Please attach the unused QR Code label to Receiving bundle and scan it';
          break;
        case 'moving-qr':
          this.title = 'Inventory Item Move between locations/shelfs';
          if (this.isTyping) { this.secondTitle = 'Please type QR Code number of Inventory Item that needs to be moved'; } else this.secondTitle = 'Please scan QR Code of Inventory Item that needs to be moved';
          break;
        default:
          this.title = '';
          this.secondTitle = '';
          break;
      }
    },

    async getActivePhysicalCountList() {
      this.physicalCountList = await this.$api.physicalCountList.getActive();
    },

    isMaintenanceClass(inventoryTag) {
      if (!inventoryTag || !inventoryTag.item || !inventoryTag.item.inventory_class_id) return false;
      return inventoryTag.item.inventory_class_id === this.inventoryClassIdMaintenance;
    },
  },
};
</script>
<style scoped>
.overlay-line {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.v-text-field--outlined .v-input__prepend-outer, .v-text-field--outlined .v-input__append-outer {
    margin-top: 0px;
}
.v-application--is-ltr .v-input__append-outer {
    margin-left: 1px;
}

</style>
